module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-wedding-zoom-fa303c6bf3b3f3fcf27a229bb2227d02.png";